import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_TRANSACTION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'TransactionText',
        name: 'Transaction Text',
        icon: 'fas fa-clipboard-list'
    },
    {
        parent: 'General.TransactionText',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_TRANSACTION.TEXT.INDEX }
    },
    {
        parent: 'General.TransactionText',
        key: 'Export',
        name: 'Import / Export',
        icon: 'fas fa-file-import',
        route: { name: ROUTE_NAME_TRANSACTION.TEXT.EXPORT }
    }
]);

export default registerRouteForModule(router);
